import type {
    S3Config,
    SftpConfig,
    HttpConfig,
    EhrConfig,
    HealthLakeConfig,
    SnowflakeConfig,
    TestConnectionRequest,
} from '../types';
import { SOURCE_TYPES } from '../constants/sourceTypes';

export const transformS3ConfigForTest = (config: S3Config): TestConnectionRequest => ({
    source_type: SOURCE_TYPES.S3.backend,
    connection_config: {
        bucket_name: config.bucketName,
        prefix: config.prefix || '',
        aws_access_key_id: config.accessKeyId,
        aws_secret_access_key: config.secretAccessKey,
        aws_region: config.region,
    },
});

export const transformSftpConfigForTest = (config: SftpConfig): TestConnectionRequest => ({
    source_type: SOURCE_TYPES.SFTP.backend,
    connection_config: {
        host: config.host,
        port: config.port,
        username: config.username,
        password: config.password,
        private_key: config.privateKey,
        item: config.remotePath,
    },
});

export const transformHttpConfigForTest = (config: HttpConfig): TestConnectionRequest => ({
    source_type: SOURCE_TYPES.HTTP.backend,
    connection_config: {
        url: config.url,
        method: config.method,
        headers: config.headers,
        auth_type: config.authType,
        username: config.username,
        password: config.password,
        bearer_token: config.bearerToken,
    },
});

export const transformEhrConfigForTest = (config: EhrConfig): TestConnectionRequest => ({
    source_type: SOURCE_TYPES.EHR.backend,
    connection_config: {
        base_url: config.baseUrl,
        client_id: config.clientId,
        client_secret: config.clientSecret,
    },
});

export const transformHealthLakeConfigForTest = (config: HealthLakeConfig): TestConnectionRequest => ({
    source_type: SOURCE_TYPES.HEALTHLAKE.backend,
    connection_config: {
        aws_access_key_id: config.accessKeyId,
        aws_secret_access_key: config.secretAccessKey,
        aws_region: config.region,
        datastore_id: config.datastoreId,
    },
});

export const transformSnowflakeConfigForTest = (config: SnowflakeConfig): TestConnectionRequest => ({
    source_type: SOURCE_TYPES.SNOWFLAKE.backend,
    connection_config: {
        user: config.username,
        password: config.password,
        account: config.account,
        warehouse: config.warehouse,
        database: config.database,
        schema: config.schema,
        role: config.role || '',
        stage_name: config.stageName || '',
        filename: config.filename || '',
    },
});
